// src/app/app.component.ts
import { afterNextRender, Component, inject, OnInit, PLATFORM_ID, NgZone, ApplicationRef } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
  RouterOutlet
} from '@angular/router';
import { ThemeService } from './services/theme.service';
import { NotificationService } from './services/notification.service';
import { TranslationService } from './services/translation.service';
import { SHARED_IMPORTS } from './shared/shared-imports'; // Asumo que esto contiene CommonModule y otros necesarios
import { concat, filter, first, interval } from 'rxjs';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { ToastServiceService } from './services/toast-service.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'Chats Random!'; 
  
}